import SingleCounselorStickyBookingButton from './components/SingleCounselorStickyBookingButton.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';
import store from 'Stores/store';

const singleCounselorStickyBookingButton = document.getElementById(
  'vue-single-counselor-sticky-booking-button'
);

if (singleCounselorStickyBookingButton) {
  const advisorId =
    singleCounselorStickyBookingButton.getAttribute('data-advisor-id');
  const schedule = JSON.parse(
    singleCounselorStickyBookingButton.getAttribute('data-schedule')
  );

  const initLazyComponent = new InitLazyComponent({
    selectors: singleCounselorStickyBookingButton,
    components: { SingleCounselorStickyBookingButton },
    data: { advisorId, schedule },
    template: `<SingleCounselorStickyBookingButton :advisorId="advisorId" :schedule="schedule" />`,
    store,
  });

  initLazyComponent.init();
}
